import { createBrowserRouter, Navigate } from "react-router-dom";
import CreatorPublicationSwiper from "../components/CreatorPublicationSwiper/CreatorPublicationSwiper";
import FanBookmarkFeedDetailsComponent from "../components/FanBookmarkFeedDetailsComponent";
import FanBookmarksComponent from "../components/FanBookmarksComponent";
import MainFeedDetailsComoponent from "../components/MainFeedDetailsComponent";
import { PageTracker } from "../components/PageTracker";
import ProtectedRoute from "../components/ProtectedRoute";
import RedirectToProfileComponent from "../components/RedirectToProfileComponent";
import PublicTrackLinkView from "../components/TrackingLink/PublicTrackLinkView/PublicTrackLinkView";
import TrackingLinkDetailsView from "../components/TrackingLink/TrackLinkDetailsView/TrackLinkDetailsView";
import TrackLinkTracker from "../components/TrackLinkTracker";
import { USER_TYPES } from "../helpers/constant";
import { PreviousLocationProvider } from "../helpers/PreviousLocationContext";
import MainLayout from "../layouts/MainLayout";
import AuthChangePasswordPage from "../pages/AuthPages/ChangePasswordPage";
import ConfirmPasswordChangedPage from "../pages/AuthPages/ConfirmPasswordChangedPage";
import EmailVerifiedPage from "../pages/AuthPages/EmailVerifiedPage";
import ForgotPasswordPage from "../pages/AuthPages/ForgotPasswordPage";
import IntroPage from "../pages/AuthPages/IntroPage";
import SignInPage from "../pages/AuthPages/SignInPage";
import SignUpPage from "../pages/AuthPages/SignUpPage";
import AuthSignUpGoogleFanPage from "../pages/AuthPages/SignUpPage/AuthSignUpGoogleFanPage";
import BlogArticlePage from "../pages/BlogPages/BlogArticle/BlogArticlePage";
import HomeBlogComponent from "../pages/BlogPages/HomeBlog";
import ChangePasswordPage from "../pages/CommonPages/ChangePasswordPage";
import CollectionPage from "../pages/CommonPages/CollectionPage";
import CreatorsProfilesPage from "../pages/CommonPages/CreatorsProfilesPage";
import DecryptPage from "../pages/CommonPages/DecryptPage";
import DecryptPaymentPage from "../pages/CommonPages/DecryptPaymentPage";
import DecryptUnlockedPage from "../pages/CommonPages/DecryptUnlockedPage";
import DiscoverPage from "../pages/CommonPages/DiscoverPage";
import HelpContactPage from "../pages/CommonPages/HelpContactPage";
import HomePage from "../pages/CommonPages/HomePage/HomePage";
import LanguagePage from "../pages/CommonPages/LanguagePage";
import ContentPolicyAndChildProtection from "../pages/CommonPages/LegalPages/ContentPolicyAndChildProtection";
import GeneralCondtionOfSale from "../pages/CommonPages/LegalPages/GeneralConditionOfSale";
import GeneralCondtionOfUse from "../pages/CommonPages/LegalPages/GeneralCondtionOfUse";
import LiveReplayDetailPage from "../pages/CommonPages/LiveReplayDetailPage/LiveReplayDetailPage";
import NewMessagePage from "../pages/CommonPages/NewMessagePage";
import PaymentRedirectPage from "../pages/CommonPages/PaymentRedirectPage/PaymentRedirectPage";
import PaymentSuccess from "../pages/CommonPages/PaymentSuccess/PaymentSuccess";
import PersonalInformationsPageV2 from "../pages/CommonPages/PersonalInformationsPage/PersonalInformationsPage";
import ConfidentialAndDataProtectionPage from "../pages/CommonPages/PolicyPages/ConfidentialAndDataProtectionPage";
import ContactPage from "../pages/CommonPages/PolicyPages/ContactPage";
import ContentPolicyPage from "../pages/CommonPages/PolicyPages/ContentPolicyPage";
import GeneralSalesConditionPage from "../pages/CommonPages/PolicyPages/GeneralSalesConditionPage";
import GeneralUseConditions from "../pages/CommonPages/PolicyPages/GeneralUseConditions";
import LegalNoticePage from "../pages/CommonPages/PolicyPages/LegalNoticePage";
import PresentationVideoOfCreatorPage from "../pages/CommonPages/PresentationVideoOfCreatorPage";
import PrivateGalleryPage from "../pages/CommonPages/PrivateGalleryPage";
import CurrentUserProfilePage from "../pages/CommonPages/ProfilePage/CurrentUserProfilePage";
import ProfilePageWrapper from "../pages/CommonPages/ProfilePage/ProfilePageWrapper";
import SavedCardsPage from "../pages/CommonPages/SavedCardsPage/SavedCardsPage";
import SaveCardPage from "../pages/CommonPages/SaveNewCardPage";
import SettingPage from "../pages/CommonPages/SettingPage";
import BlockedFansList from "../pages/CreatorPages/BlockedFansList/BlockedFansList";
import ChatScriptsCreateView from "../pages/CreatorPages/ChatScriptsView/ChatScriptsCreateView/ChatScriptsCreateView";
import ChatScriptsView from "../pages/CreatorPages/ChatScriptsView/ChatScriptsView";
import ChatScriptUpdateView from "../pages/CreatorPages/ChatScriptsView/ChatScriptUpdateView/ChatScriptUpdateView";
import EditScriptOrderView from "../pages/CreatorPages/ChatScriptsView/EditScriptOrderView/EditScriptOrderView";
import CreatorCollectionPage from "../pages/CreatorPages/Collections/CreatorCollectionPage";
import CreatorCreateCollectionPage from "../pages/CreatorPages/Collections/CreatorCreateCollectionPage";
import CreatorDetailCollectionPage from "../pages/CreatorPages/Collections/CreatorDetailCollectionPage";
import CreatorEditCollectionPage from "../pages/CreatorPages/Collections/CreatorEditCollectionPage";
import CreatorAddMediaComponent from "../pages/CreatorPages/CreatorAddMediaComponent";
import CreatorAlbumFeedsComponent from "../pages/CreatorPages/CreatorAlbumFeedsComponent";
import CreatorAllSubscribers from "../pages/CreatorPages/CreatorAllSubscribers";
import CreatorAutomaticMessage from "../pages/CreatorPages/CreatorAutomaticMessage/CreatorAutomaticMessage";
import CreatorAutomaticMessageEditPage from "../pages/CreatorPages/CreatorAutomaticMessageEditPage/CreatorAutomaticMessageEditPage";
import CreatorBillingAddress from "../pages/CreatorPages/CreatorBillingAddress";
import CreatorCodePromotionCreate from "../pages/CreatorPages/CreatorCodePromotionCreate";
import CreatorCodePromotions from "../pages/CreatorPages/CreatorCodePromotions";
import CreatorConversationPage from "../pages/CreatorPages/CreatorConversationPage";
import CreatorCreateAudioComponent from "../pages/CreatorPages/CreatorCreateAudioComponent";
import CreatorCreateDecryptPage from "../pages/CreatorPages/CreatorCreateDecryptPage";
import CreatorCreateNewAlbumComponent from "../pages/CreatorPages/CreatorCreateNewAlbumComponent";
import CreatorDecryptDetailsPage from "../pages/CreatorPages/CreatorDecryptDetailsPage";
import CreatorDecryptPage from "../pages/CreatorPages/CreatorDecryptPage";
import CreatorEditProfilePage from "../pages/CreatorPages/CreatorEditProfilePage";
import CreatorHistoryMediaPushPage from "../pages/CreatorPages/CreatorHistoryMediaPushPage";
import CreatorImportationPage from "../pages/CreatorPages/CreatorImportationPage";
import CreatorLiveBroadcastPage from "../pages/CreatorPages/CreatorLiveBroadcastPage/CreatorLiveBroadcastPage";
import CreatorLiveEventDetailPage from "../pages/CreatorPages/CreatorLiveEventDetailPage";
import CreatorLivePage from "../pages/CreatorPages/CreatorLivePage";
import CreatorLivePublishPage from "../pages/CreatorPages/CreatorLivePublishPage";
import CreatorMediaPushPage from "../pages/CreatorPages/CreatorMediaPushPage";
import CreatorMessagePage from "../pages/CreatorPages/CreatorMessagePage";
import CreatorMonetizationPage from "../pages/CreatorPages/CreatorMonetizationPage";
import CreatorNewMessageResponsePage from "../pages/CreatorPages/CreatorNewMessageResponsePage";
import CreatorNewPaymentMethodPage from "../pages/CreatorPages/CreatorNewPaymentMethodPage";
import CreatorPaymentHistoryPage from "../pages/CreatorPages/CreatorPaymentHistoryPage";
import CreatorPaymentMethodPage from "../pages/CreatorPages/CreatorPaymentMethodPage";
import CreatorPerformancePage from "../pages/CreatorPages/CreatorPerformancePage";
import CreatorPublicationPage from "../pages/CreatorPages/CreatorPublicationPage";
import CreatorPutStoryPage from "../pages/CreatorPages/CreatorPutStoryPage";
import CreatorQuickLinkComponent from "../pages/CreatorPages/CreatorQuickFileComponent";
import CreatorRevenuePage from "../pages/CreatorPages/CreatorRevenuePage";
import CreatorSponsorshipPage from "../pages/CreatorPages/CreatorSponsorshipPage";
import TrackingLinkCreateView from "../pages/CreatorPages/CreatorTrackingLinks/CreateTrakingLink/CreateTrakingLink";
import CreatorTrackingLinksPage from "../pages/CreatorPages/CreatorTrackingLinks/CreatorTrackingLinksPage";
import CreatePresentationVideoPage from "../pages/CreatorPages/Discover/CreatePresentationVideoPage";
import CreatorFormationPage from "../pages/CreatorPages/Formations/CreatorFormationPage";
import FormationPage from "../pages/CreatorPages/Formations/FormationPage";
import InvitationManagerPage from "../pages/CreatorPages/InvitationManagerPage/InvitationManagerPage";
import LiveReplaysPage from "../pages/CreatorPages/LiveReplaysPage/LiveReplaysPage";
import QuickMessagesPage from "../pages/CreatorPages/QuickMessagesPage/QuickMessagesPage";
import VoiceChatList from "../pages/CreatorPages/VoiceChatList/VoiceChatList";
import FanBugPage from "../pages/FanPages/FanBugPage";
import FanEmailNotificationPage from "../pages/FanPages/FanEmailNotificationSetting/FanEmailNotificationPage";
import FanEventPage from "../pages/FanPages/FanEventPage";
import FanEventPageWrapper from "../pages/FanPages/FanEventPage/FanEventPageWrapper";
import FanHomePage from "../pages/FanPages/FanHomePage";
import FanHomeMessagerieWrapper from "../pages/FanPages/FanHomePage/FanHomeMessagerieWrapper";
import FanLiveBroadcastPage from "../pages/FanPages/FanLiveBroadcastPage/FanLiveBroadcastPage";
import FanLivePage from "../pages/FanPages/FanLivePage";
import FanLivesPageWrapper from "../pages/FanPages/FanLivesPage/FanLivesPageWrapper";
import FanMessagePage from "../pages/FanPages/FanMessagePage";
import FanNotificationPage from "../pages/FanPages/FanNotificationPage";
import FanPaymentPage from "../pages/FanPages/FanPaymentPage";
import FanPaymentRTMPPage from "../pages/FanPages/FanPaymentRTMPPage/FanPaymentRTMPPage";
import FanRequestMediaPage from "../pages/FanPages/FanRequestMediaPage";
import FanSubscribePage from "../pages/FanPages/FanSubscribePage";
import FanSubscriptionPage from "../pages/FanPages/FanSubscriptionPage/FanSubscriptionPage";
import { authService } from "../services";

const LayoutWithPreviousLocation = () => (
  <PreviousLocationProvider>
    <TrackLinkTracker />
    <PageTracker />
    <MainLayout />
  </PreviousLocationProvider>
);

const ProtectedLayoutWithPreviousLocation = () => (
  <ProtectedRoute>
    <PreviousLocationProvider>
      <TrackLinkTracker />
      <PageTracker />
      <MainLayout />
    </PreviousLocationProvider>
  </ProtectedRoute>
);

const publicRoutes = [
  {
    path: "/p",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        path: "/p/:username",
        element: <ProfilePageWrapper />,
      },
      {
        path: "/p/fan/lives",
        element: <FanLivesPageWrapper />,
      },
      {
        path: "/p/fan/event/:id",
        element: <FanEventPageWrapper />,
      },
    ],
  },
  {
    path: "/tracking/:token",
    element: <PublicTrackLinkView />,
  },
];

const collectionRedirection = [
  {
    path: "/common",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        path: "/common/collection/:collectionId/:username",
        element: <RedirectToProfileComponent />,
      },
    ],
  },
];

const authRoutes = [
  {
    path: "/auth",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        index: true,
        element: <Navigate to="/auth/intro" replace />,
      },
      {
        path: "/auth/intro",
        element: <IntroPage />,
      },
      {
        path: "/auth/signIn",
        element: <SignInPage />,
      },
      {
        path: "/auth/signUp",
        element: <SignUpPage />,
      },
      {
        path: "/auth/signUp/google",
        element: <AuthSignUpGoogleFanPage />,
      },
      {
        path: "/auth/forgot",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/auth/forgot/changePassword",
        element: <AuthChangePasswordPage />,
      },
      {
        path: "/auth/forgot/confirm",
        element: <ConfirmPasswordChangedPage />,
      },
      {
        path: "/auth/emailVerified",
        element: <EmailVerifiedPage />,
      },
    ],
  },
];

const fanRoutes = [
  {
    path: "/fan",
    element: <LayoutWithPreviousLocation />,
    children: [
      // {
      //   index: true,
      //   element: <Navigate to="/fan/home" replace />,
      // },
      {
        index: true,
        element: <FanHomeMessagerieWrapper />,
      },
      {
        path: "/fan/home",
        element: <FanHomePage />,
      },
      {
        path: "/fan/notification",
        element: <FanNotificationPage />,
      },
      {
        path: "/fan/message",
        element: <FanMessagePage />,
      },
      {
        path: "/fan/requestMedia/:conversationId",
        element: <FanRequestMediaPage />,
      },
      {
        path: "/fan/subscribe/:creatorId",
        element: <FanSubscribePage />,
      },
      {
        path: "/fan/payment",
        element: <FanPaymentPage />,
      },
      {
        path: "/fan/live/:id",
        element: <FanLivePage />,
      },
      {
        path: "/fan/live-broadcast/:id",
        element: <FanLiveBroadcastPage />,
      },
      {
        path: "/fan/event/:id",
        element: <FanEventPage />,
      },
      {
        path: "/fan/bookmarks",
        element: <FanBookmarksComponent />,
      },
      {
        path: "/fan/bookmarkFeed/:id",
        element: <FanBookmarkFeedDetailsComponent />,
      },
      {
        path: "/fan/subscription",
        element: <FanSubscriptionPage />,
      },
      {
        path: "/fan/spottedbug",
        element: <FanBugPage />,
      },
      {
        path: "/fan/emailNotification",
        element: <FanEmailNotificationPage />,
      },
      // {
      //   path: "/fan/sebyvsstrongui",
      //   element: <FanLiveEventTicketPage />,
      // },
    ],
  },
  {
    path: "/*",
    element: <FanHomeMessagerieWrapper />,
  },
];

const creatorRoutes = [
  {
    path: "/creator",
    element: <ProtectedLayoutWithPreviousLocation />,
    children: [
      {
        index: true,
        element: <Navigate to="/creator/profile" replace />,
      },
      {
        path: "/creator/revenue",
        element: <CreatorRevenuePage />,
      },
      {
        path: "/creator/monetization",
        element: <CreatorMonetizationPage />,
      },
      {
        path: "/creator/quick/message",
        element: <QuickMessagesPage />,
      },
      {
        path: "/creator/codePromotions",
        element: <CreatorCodePromotions />,
      },
      {
        path: "/creator/codePromotion/create",
        element: <CreatorCodePromotionCreate />,
      },
      {
        path: "/creator/sponsorship",
        element: <CreatorSponsorshipPage />,
      },
      {
        path: "/creator/paymentHistory",
        element: <CreatorPaymentHistoryPage />,
      },
      {
        path: "/creator/paymentMethod",
        element: <CreatorPaymentMethodPage />,
      },
      {
        path: "/creator/newPaymentMethod",
        element: <CreatorNewPaymentMethodPage />,
      },
      {
        path: "/creator/historyMediaPush",
        element: <CreatorHistoryMediaPushPage />,
      },
      {
        path: "/creator/performance/:mediaPushId",
        element: <CreatorPerformancePage />,
      },
      {
        path: "/creator/mediaPush",
        element: <CreatorMediaPushPage />,
      },
      {
        path: "/creator/importation",
        element: <CreatorImportationPage />,
      },
      {
        path: "/creator/live",
        element: <CreatorLivePage />,
      },
      {
        path: "/creator/live/publish/:id",
        element: <CreatorLivePublishPage />,
      },
      {
        path: "/creator/live/broadcast/:id",
        element: <CreatorLiveBroadcastPage />,
      },
      {
        path: "/creator/live/event/detail/:id",
        element: <CreatorLiveEventDetailPage />,
      },
      {
        path: "/creator/putStory",
        element: <CreatorPutStoryPage />,
      },
      {
        path: "/creator/publication",
        element: <CreatorPublicationPage />,
      },
      {
        path: "/creator/message",
        element: <CreatorMessagePage />,
      },
      {
        path: "/creator/conversation/:conversationId",
        element: <CreatorConversationPage />,
      },
      {
        path: "/creator/newResponse",
        element: <CreatorNewMessageResponsePage />,
      },
      {
        path: "/creator/profile",
        element: <CurrentUserProfilePage />,
      },
      {
        path: "/creator/editProfile",
        element: <CreatorEditProfilePage />,
      },
      {
        path: "/creator/decrypt",
        element: <CreatorDecryptPage />,
      },
      {
        path: "/creator/decrypt/:decryptId",
        element: <CreatorDecryptDetailsPage />,
      },
      {
        path: "/creator/createDecrypt",
        element: <CreatorCreateDecryptPage />,
      },
      {
        path: "/creator/quickLink",
        element: <CreatorQuickLinkComponent />,
      },
      {
        path: "/creator/createNewAlbum",
        element: <CreatorCreateNewAlbumComponent />,
      },
      {
        path: "/creator/AddMedia/:albumId",
        element: <CreatorAddMediaComponent />,
      },
      {
        path: "/creator/AddMedia/:albumId/audio",
        element: <CreatorCreateAudioComponent />,
      },
      {
        path: "/creator/AlbumFeeds/:albumId",
        element: <CreatorAlbumFeedsComponent />,
      },
      {
        path: "/creator/AlbumFeeds/:albumId/audios",
        element: <VoiceChatList />,
      },
      {
        path: "/creator/allSubscribers",
        element: <CreatorAllSubscribers />,
      },
      {
        path: "/creator/billingAddress",
        element: <CreatorBillingAddress />,
      },
      {
        path: "/creator/collection",
        element: <CreatorCollectionPage />,
      },
      {
        path: "/creator/collection/:collectionId/:username",
        element: <CreatorDetailCollectionPage />,
      },
      {
        path: "/creator/create/collection",
        element: <CreatorCreateCollectionPage />,
      },
      {
        path: "/creator/edit/collection/:collectionId/:title/:price",
        element: <CreatorEditCollectionPage />,
      },
      {
        path: "/creator/formation",
        element: <CreatorFormationPage />,
      },
      {
        path: "/creator/formation/:id",
        element: <FormationPage />,
      },
      {
        path: "/creator/message-automatic",
        element: <CreatorAutomaticMessage />,
      },
      {
        path: "/creator/blocked-fans",
        element: <BlockedFansList />,
      },
      {
        path: "/creator/tracking-links",
        element: <CreatorTrackingLinksPage />,
      },
      {
        path: "/creator/tracking-links/create",
        element: <TrackingLinkCreateView />,
      },
      {
        path: "/creator/tracking-links/:id",
        element: <TrackingLinkDetailsView />,
      },
      {
        path: "/creator/message-automatic/:block",
        element: <CreatorAutomaticMessageEditPage />,
      },
      {
        path: "/creator/create/presentation/videos",
        element: <CreatePresentationVideoPage />,
      },
      {
        path: "/creator/invitation-manager",
        element: <InvitationManagerPage />,
      },
      {
        path: "/creator/chat-scripts",
        element: <ChatScriptsView />,
      },
      {
        path: "/creator/chat-scripts/create",
        element: <ChatScriptsCreateView />,
      },
      {
        path: "/creator/chat-scripts/update",
        element: <ChatScriptUpdateView />,
      },
      {
        path: "/creator/chat-scripts/order",
        element: <EditScriptOrderView />,
      },
      {
        path: "/creator/live-replays",
        element: <LiveReplaysPage />,
      },
    ],
  },
  {
    path: "/*",
    element: <Navigate to="/creator/profile" replace />,
  },
];

const commonRoutes = [
  {
    path: "/common",
    element: <LayoutWithPreviousLocation />,
    children: [
      // {
      //   path: "/common/category/search",
      //   element: <CategorySearchPage />,
      // },
      // {
      //   path: "/common/search/:categoryName",
      //   element: <SearchPage />,
      // },
      {
        path: "/common/privateGallery",
        element: <PrivateGalleryPage />,
      },
      {
        path: "/common/setting",
        element: <SettingPage />,
      },
      {
        path: "/common/changePassword",
        element: <ChangePasswordPage />,
      },
      {
        path: "/common/personalInformations",
        element: <PersonalInformationsPageV2 />,
      },
      {
        path: "/common/language",
        element: <LanguagePage />,
      },
      {
        path: "/common/helpContact",
        element: <HelpContactPage />,
      },
      {
        path: "/common/messages/new",
        element: <NewMessagePage />,
      },
      {
        path: "/common/payment",
        element: <FanPaymentPage />,
      },
      {
        path: "/common/event-payment",
        element: <FanPaymentRTMPPage />,
      },
      {
        path: "/common/subscribe/:creatorId",
        element: <FanSubscribePage />,
      },
      {
        path: "/common/feeds/:id/:userID",
        element: <MainFeedDetailsComoponent />,
      },
      {
        path: "/common/publications/:id/:userID",
        element: <CreatorPublicationSwiper />,
      },
      {
        path: "/common/savedCards",
        element: <SavedCardsPage />,
      },
      {
        path: "/common/saveNewCard",
        element: <SaveCardPage />,
      },
      {
        path: "/common/collection/:collectionId/:username",
        element: <CollectionPage />,
      },
      {
        path: "/common/discover",
        element: <DiscoverPage />,
      },
      {
        path: "/common/presentation/videos/:username",
        element: <PresentationVideoOfCreatorPage />,
      },
      {
        path: "/common/general-conditions-of-use",
        element: <GeneralCondtionOfUse />,
      },
      {
        path: "/common/general-conditions-of-sale",
        element: <GeneralCondtionOfSale />,
      },
      {
        path: "/common/content-policy-and-child-protection",
        element: <ContentPolicyAndChildProtection />,
      },
      {
        path: "/common/quick-file",
        element: <CreatorQuickLinkComponent />,
      },
      {
        path: "/common/live-replays/:id",
        element: <LiveReplayDetailPage />,
      },
    ],
  },
];

const decryptRoutes = [
  {
    path: "/decrypt",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        path: "/decrypt",
        element: <DecryptPage />,
      },
      {
        path: "/decrypt/payment/:decryptId",
        element: <DecryptPaymentPage />,
      },
      {
        path: "/decrypt/unlocked",
        element: <DecryptUnlockedPage />,
      },
    ],
  },
];

const paymentRoutes = [
  {
    path: "/payment",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        path: "/payment/success",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/cancel",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/fail",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/redirect",
        element: <PaymentRedirectPage />,
      },
    ],
  },
];

const mainRoutes = [
  {
    path: "/",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/profiles",
        element: <CreatorsProfilesPage />,
      },
      {
        path: "/content-policy-and-child-protection",
        element: <ContentPolicyPage />,
      },
      {
        path: "/legal-notices",
        element: <LegalNoticePage />,
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "/general-conditions-of-sale",
        element: <GeneralSalesConditionPage />,
      },
      {
        path: "/general-conditions-of-use",
        element: <GeneralUseConditions />,
      },
      {
        path: "/confidentiality-and-data-protection",
        element: <ConfidentialAndDataProtectionPage />,
      },
      // {
      //   path: "/sebyvsstrongui",
      //   element: <FanLiveEventWrapper />,
      // },
    ],
  },
];

const blogRoutes = [
  {
    path: "/blogs",
    element: <LayoutWithPreviousLocation />,
    children: [
      {
        index: true,
        element: <HomeBlogComponent />,
      },
      {
        path: ":slug",
        element: <BlogArticlePage />,
      },
    ],
  },
];

let router: any;

if (!authService.isAuthenticated()) {
  router = createBrowserRouter([
    ...authRoutes,
    ...blogRoutes,
    ...decryptRoutes,
    ...publicRoutes,
    ...paymentRoutes,
    ...collectionRedirection,
    ...mainRoutes,
    {
      path: "/*",
      element: <Navigate to="/auth/intro" replace />,
    },
  ]);
} else {
  if (authService.getRole() === USER_TYPES.FAN) {
    router = createBrowserRouter([...blogRoutes, ...publicRoutes, ...fanRoutes, ...commonRoutes, ...decryptRoutes, ...paymentRoutes]);
  } else if (authService.getRole() === USER_TYPES.CREATOR) {
    // Include authRoutes for creators with incomplete registration so /auth/signUp is accessible
    const isRegistrationComplete = authService.isCreatorRegistrationComplete();
    if (isRegistrationComplete) {
      router = createBrowserRouter([...blogRoutes, ...publicRoutes, ...creatorRoutes, ...commonRoutes, ...decryptRoutes, ...paymentRoutes]);
    } else {
      // Registration incomplete: include authRoutes and redirect root to signup.
      const decodedToken = authService.getDecodedToken();
      const incompleteCreatorRedirect = [
        {
          path: "/",
          element: <Navigate to={`/auth/signUp?id=${decodedToken.sourceId}&email=${decodedToken.email || ""}&currentTab=creator`} replace />,
        },
      ];
      router = createBrowserRouter([
        ...authRoutes,
        ...incompleteCreatorRedirect,
        ...blogRoutes,
        ...publicRoutes,
        ...commonRoutes,
        ...decryptRoutes,
        ...paymentRoutes,
      ]);
    }
  }
}

export default router;
